import { Img } from "../images/Images";

export const Bio = {
    name: "Sai Aravind Appalabhakthula",
    roles: [
      "Front-end Developer.",
      "Data Analyst.",
      "Programmer.",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/saiaravind0014",
    resume:
      "https://drive.google.com/file/d/1aWq1SJzQHJmRM13Gfizl4V0ugz1pQ6Dm/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/sai-aravind-appalabhakthula-242122214/",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "Express Js",
          image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAbFBMVEX////8/Pz09PT19fX4+Pjd3d2ampoAAAAzNDWoqKno6Oh0dHRcXFzIycm5ubktLi4hIiN7e3yLi4tmZ2fi4uI9Pj7S0tIHCQuzs7NJSkru7u6goKB+f3/W1taNjo69vb1PT1BsbW0VFRc3ODhehn9TAAAA30lEQVR4Ad3QhXHEMBBA0W8QmAVmTq7/HjOeDdSQewNiLfBukjRNM4A0TeCR/0wSpY0xtiihMgWPsraNnLWd8yFEE3vyOIwAeprhMQ5Lm8O6uT3hWPwKjQspj+zsLvlBuwNmV1DaukS+t3sqs8MWkAU7ejMiGnMhkjoCqnZmQ3CZPwM8Hy/8Hd7xF7BWzjQIxulCsJaQbG6r7xXR2zNHrn1s0AwhUdNPjunejTLxTlHedS89EOMwFAkobzR4ewFptRyI9tPY18uZkFIYzUO5akWU22BflYKx2xGX1Rn/yxf+uwzyBt/vSwAAAABJRU5ErkJggg==",
        },
        // {
        //   name: "MongoDB",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        // },
        // {
        //   name: "Graph Ql",
        //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
        // },
        // {
        //   name: "Python",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        // },
        // {
        //   name: "MySQL",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        // },
        // {
        //   name: "Postgresql",
        //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        // },
        
        // {
        //   name: "Firebase",
        //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        // },
      ],
    },
    {
      title: "Query Languages",
      skills: [
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
      ],
    },
    {
      title: "Tools and Technologies",
      skills: [
        {
          name: "Git",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "Tableau",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "Power BI",
          image:
            "https://cdn-dynmedia-1.microsoft.com/is/image/microsoftcorp/Analysts_PBI?resMode=sharp2&op_usm=1.5,0.65,15,0&wid=2000&qlt=99&fmt=png-alpha&fit=constrain",
        },
      ],
    },
    // {
    //   title: "Android",
    //   skills: [
    //     {
    //       name: "Java",
    //       image:
    //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    //     },
    //     {
    //       name: "Kotlin",
    //       image:
    //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
    //     },
    //     {
    //       name: "XML",
    //       image:
    //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
    //     },
    //     {
    //       name: "Android Studio",
    //       image:
    //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
    //     },
    //   ],
    // },
    // {
    //   title: "Others",
    //   skills: [
    //     {
    //       name: "Git",
    //       image:
    //         "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
    //     },
    //     {
    //       name: "GitHub",
    //       image:
    //         "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    //     },
    //     {
    //       name: "Docker",
    //       image:
    //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
    //     },
    //     {
    //       name: "Netlify",
    //       image:
    //         "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
    //     },
    //     {
    //       name: "VS Code",
    //       image:
    //         "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
    //     },
    //     {
    //       name: "Postman",
    //       image:
    //         "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
    //     },
    //     {
    //       name: "Adobe XD",
    //       image:
    //         "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
    //     },
    //     {
    //       name: "Figma",
    //       image:
    //         "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
    //     },
    //   ],
    // },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: Img.nsic,
      role: "Intern Trainee",
      company: "National Small Industries Corporation Pvt. Ltd.",
      date: "26 June 2023 - 10 July 2023",
      desc: "Internship Training on Industrial Based Embedded Systems with AI & IOT.",
      skills: [
        
      ],
      // doc: "https://drive.google.com/file/d/1e9SHtYUIDqqcWScoiws5Wit0bMT7dKBp/view?usp=sharing",
    },
    {
      id: 1,
      img: Img.jorim,
      role: "Frontend Engineer Intern",
      company: "Jorim Technology Solutions Pvt Ltd",
      date: "13 September 2023 - 14 October 2023",
      desc: "Working on the frontend of the web application using ReactJS, HTML, CSS.",
      skills: [
        "ReactJS",
        "NodeJs",
        "HTML",
        "CSS",
        "JavaScript",
      ],
      // doc: "",
    },
    {
      id: 2,
      img: Img.innovik,
      role: "Front-End Developer",
      company: "INNOVIK Technologies",
      date: "September 2023 - January 2024",
      desc: "Did few Projects as an Intern at Innovik Technologies",
      skills: [
        "ReactJS",
        "NodeJs",
        "HTML",
        "CSS",
        "JavaScript",
      ],
    },

  ];
  
  export const education = [
    {
      id: 0,
      img: Img.chaitanya,
      school: "Sri Chaitanya Techno School, Rajahmundry",
      date: "March 2018",
      grade: "9.8 CGPA",
      desc: "I completed my class 10 education at Sri Chaitanya Techno School, Rajahmundry, where I studied in State Board of Andhra Pradesh.",
      degree: "State Board(X)",
    },
    {
      id: 1,
      img: Img.tirumala,
      school: "Tirumala College, Rajahmundry",
      date: "March 2020",
      grade: "9.01 CGPA",
      desc: "I completed my class 12 high school education at Tirumala College, Rajahmundry, where I studied MPC.",
      degree: "State Board(XII), MPC",
    },
    {
      id: 2,
      img: Img.sairam,
      school: "Sri Sai Ram Institute of Technology",
      date: "August 2020 - Present",
      grade: "8.2 CGPA",
      desc: "I am currently pursuing a Bachelor's degree in Artificial Intelligence and Data Science at Sri Sai Ram Institute of Technology, Chennai. I have completed 7 semesters and have a CGPA of 8.21.",
      degree: "Bachelor's degree in Artificial Intelligence and Data Science, Sri Sai Ram Institute of Technology",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "Driver Mentality and Detection System",
      date: "September 2022 - Present",
      description:
        "Most of the people are using four wheelers and heavy vehicles everywhere in day-day life. And their risk of losing lives due to drowsiness and mental stress like emotion detection during driving is increasing. So, our objective is to prevent these accidents thus we build a system by using deep learning, machine learning and neural networking, we can save their lives and avoid property damages.",
      image:
        "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "PYTHON",
        "JUPITER NOTEBOOK",
        "OpenCV",
        "KERAS",
        "TensorFlow",
      ],
      category: "Machine Learning",
    },
    {
      id: 1,
      title: "Portfolio",
      date: "Febuary 2024",
      description:
        "Developed a dynamic portfolio website using React JS, showcasing sections for About Me, Experience, Education, Projects, and Skills. Integrated a resume attachment within the About Me section and included links to social media profiles in the footer. Proficiently utilized Node.js and JavaScript in project development.",
      // image:
      //   "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "ReactJS",
        "JavaScript",
        "Node JS",
      ],
      category: "web app",
    },
    {
      id: 2,
      title: "TODO List App",
      date: "Febuary 2024",
      description:
        "Developed a versatile Todo List application enabling task addition, deletion, and editing through user-friendly buttons. Implemented a clear list format for easy task viewing.",
      // image:
      //   "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "ReactJS",
        "JavaScript",
        "Node JS",
      ],
      category: "web app",
    },
    {
      id: 3,
      title: "E-Commerce",
      date: "March 2024",
      description:
        "I have developed an e-commerce website that prioritizes user-friendliness. The platform enables users to easily browse, purchase, and view products. It features a robust cart system that allows for the addition and removal of items. Each product is thoughtfully categorized by product item type, enhancing the overall shopping experience.",
      // image:
      //   "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "ReactJS",
        "JavaScript",
        "Node JS",
      ],
      category: "web app",
    },
    {
      id: 4,
      title: "Book Store",
      date: "March 2024",
      description:
        "I have developed a sophisticated bookstore application that leverages MongoDB, Express.js, React.js, and Node.js (MERN stack) for seamless functionality. This app efficiently manages a collection of books, offering features such as adding, deleting, updating, and viewing detailed book information. The utilization of these technologies ensures a robust and efficient user experience.",
      // image:
      //   "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "MongoDB",
        "ExpressJS",
        "ReactJS",
        "Node JS",
        "JavaScript",
      ],
      category: "web app",
    },
      {
      id: 4,
      title: "Sales Analysis",
      date: "June 2024",
      description:
        "I have developed a Sales Dashboard which contains Revenue and Profit Analysis by connecting the sql server by using Tableau tool",
      // image:
      //   "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "Mysql",
      ],
      category: "others",
    },
  ];
  
